import { SubstitutionPlanModal } from "@/modals/users/substitution-plan-modal";
import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Fragment } from "@msuite/ui/utils";
import type { Substitution } from "@msuite/utils/types";

/** Props Interface */
interface ProcessSubstitutionPendingProps {
	substitution: Substitution;
}

export function ProcessSubstitutionPending({ substitution }: ProcessSubstitutionPendingProps) {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Button
				className="w-[200px] h-stack justify-start"
				onClick={disclosure.onOpen}
				icon={<Icon name="Edit" />}
				variant="ghost"
			>
				{t("substitutions.edit_substitution_plan")}
			</Button>
			{disclosure.isOpen && (
				<SubstitutionPlanModal
					key={substitution.id}
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					absenceId={substitution.id}
					startDate={substitution.startDate}
					endDate={substitution.endDate}
				/>
			)}
		</Fragment>
	);
}
